import Glide from '@glidejs/glide';
import merge from 'lodash/merge';
import objectParser from '../utils/object-parser';

function initSlideshow(el) {
  if(el.glide) {
    el.glide.destroy();
  }

  const DEFAULTS = {
    type: 'carousel',
    perView: 1,
    gap: 0,
    autoplay: 4000,
    peek: { before: 0, after: 0 },
    classes: {
      type: {
        slider: 'is-init',
        carousel: 'is-init'
      },
      direction: {
        ltr: 'is-ltr',
        rtl: 'is-rtl'
      },
      swipeable: 'is-swipeable',
      dragging: 'is-dragging',
      nav: {
        active: "is-active"
      },
      slide: {
        active: 'is-active',
        clone: 'is-clone'
      },
      arrow: {
        disabled: 'is-disabled'
      }
    },
  };
  const { options } = objectParser(el.dataset);
  const settings = merge( {}, DEFAULTS, options);
  const glide = new Glide(el, settings).mount();

  el.glide = glide;
}

window.initSlideshow = initSlideshow;

document.querySelectorAll('.js-Slideshow').forEach(el => initSlideshow(el))